import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams, useLocation } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { FetchDuplicateJobData } from "helpers/backend_helper";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import startupListingModal from "pages/Founders/startup-listing-modal";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

const ViewDuplicateJobList = () => {
  const [duplicateJobData, setDuplicateJobData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  let { type } = useParams();
  const [data, setData] = useState([]);

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [queryString, setQueryString] = useState("");
  const stringToDate = dateString => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid Date string");
    }
    return date;
  };

  const getDuplicateJobData = async (type, startDate = "", endDate = "") => {
    let payload = `?type=${type}&startDate=${startDate}&endDate=${endDate}`;
    await FetchDuplicateJobData(payload)
      .then(res => {
        if (res?.status) {
          // console.log('kkkkkkkkk',res?.data?.duplicateJobData);
          setDuplicateJobData(res?.data?.duplicateJobData);
        } else {
          //   setError("No data available");
        }
      })
      .catch(err => {
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        // setError("No data Available");
      });
  };

  useEffect(() => {
    if (type === "custom") {
      // const currentUrl = window.location.href;
      const queryParams = new URLSearchParams(window.location.search);
      // Extract startDate and endDate from the query string
      const start = queryParams.get("startDate");
      const end = queryParams.get("endDate");
      getDuplicateJobData(type, start, end);
    } else {
      getDuplicateJobData(type);
    }
  }, [window.location.search]);

  const formattedData = duplicateJobData.map(job => ({
    title: job.title,
    emails: job.duplicate_emails.map(email => email.email_id).join(", "),
    totalDuplicates: job.total_duplicate_count,
  }));

  let columns = [
    {
      dataField: "title",
      text: "Title",
    },
    {
      dataField: "totalDuplicates",
      text: "Duplicate",
      classes: "white-hidden",
    },

    {
      dataField: "emails",
      text: "Email",
      classes: "white-hidden ",
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <div className="joblist-container create-vacancy">
        <Row className="mb-3 align-items-center">
          <Col lg="6" md="6">
            <Link to="/franchise-list">
              <h5 className="text-uppercase heading-one">
                <img src={arrow_btn} alt="arrow_btn" />
                Duplicate job List
              </h5>
            </Link>
          </Col>
        </Row>
      </div>

      <div className="outerTab-box-wrapper below-vacancy amsterresign">
        <div className="tabel-application tabel-application-auto table-responsive white-space-row">
          <ToolkitProvider
            keyField="head1"
            data={formattedData}
            columns={columns}
          >
            {props => (
              <div className="timeto-hire-card userlist">
                <div className="table-custome-class range-custome">
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory()}
                    options={options}
                    striped
                    hover
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
          {formattedData?.length === 0 && (
            <div className="no-data data-available">
              <img
                src="../img/data-not-available.png"
                alt="data not availble"
              />
              <h3>No Item Found</h3>
              <p>
                Sorry, we could not find any
                <br /> Item to show here.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewDuplicateJobList;
